(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('smsPatterns', {
                parent: 'entity',
                url: '/sms-patterns?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.smsPattern.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/sms-pattern/sms-patterns.html',
                        controller: 'SmsPatternController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('smsPattern');
                        $translatePartialLoader.addPart('activityType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('smsPatterns-detail', {
                parent: 'entity',
                url: '/smsPatterns/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.smsPattern.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/sms-pattern/sms-pattern-detail.html',
                        controller: 'SmsPatternDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('smsPattern');
                        $translatePartialLoader.addPart('activityType');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'SmsPattern', function ($stateParams, SmsPattern) {
                        return SmsPattern.getPatternItem().get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('smsPatterns-new', {
                parent: 'smsPatterns',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/sms-pattern/sms-pattern-dialog.html',
                        controller: 'SmsPatternDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    title: null,
                                    state: "ACTIVE",
                                    approveStatus: "APPROVED",
                                    type: "MANUAL",
                                    count: 0,
                                    createDate: "",
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('smsPatterns', null, {reload: true});
                    }, function () {
                        $state.go('smsPatterns');
                    });
                }]
            })
            .state('smsPatterns-edit', {
                parent: 'smsPatterns',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/sms-pattern/sms-pattern-dialog.html',
                        controller: 'SmsPatternDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['SmsPattern', function (SmsPattern) {
                                return SmsPattern.getPatternItem().get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('smsPatterns', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            // .state('company.delete', {
            //     parent: 'company',
            //     url: '/{id}/delete',
            //     data: {
            //         authorities: ['ROLE_USER']
            //     },
            //     onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
            //         $uibModal.open({
            //             templateUrl: 'app/entities/company/company-delete-dialog.html',
            //             controller: 'CompanyDeleteController',
            //             controllerAs: 'vm',
            //             size: 'md',
            //             resolve: {
            //                 entity: ['Company', function (Company) {
            //                     return Company.get({id: $stateParams.id}).$promise;
            //                 }]
            //             }
            //         }).result.then(function () {
            //             $state.go('company', null, {reload: true});
            //         }, function () {
            //             $state.go('^');
            //         });
            //     }]
            // });
    }

})();
